import FuseLoading from '@fuse/core/FuseLoading';
import { Suspense } from 'react';
import PropTypes from 'prop-types';

function FuseSuspense({ loadingProps = { delay: 0 }, children }) {
	return <Suspense fallback={<FuseLoading {...loadingProps} />}>{children}</Suspense>;
}

FuseSuspense.propTypes = {
  loadingProps: PropTypes.array,
  children: PropTypes.node,
};

export default FuseSuspense;
